module.exports = __webpack_public_path__ + "static/media/Bicocca - white_Sand.c83ea68d.jpg";